<template>
  <div class="container" style="background-color: #fff">
    <headerBox></headerBox>
    <bannerBox ref="bannerChild"></bannerBox>
    <div class="content_box">
      <div style="overflow-x: scroll">
        <div style="min-width: 1080px">
          <div class="common_search_box">
            <el-row :gutter="24">
              <el-col :span="16">
                <div class="search_box_item">
                  <div class="label">会员名称：</div>
                  <el-input
                    v-model="params.dwmc"
                    class="gzdwInput"
                    placeholder="请输入会员名称搜索"
                    style="width: 72.5%"
                    @change="toSearch"
                  >
                  </el-input>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="search_box_item">
                  <div class="label">会员类型：</div>
                  <el-select
                    v-model="params.type"
                    placeholder="请选择会员类型"
                    style="width: 80%"
                    @change="getType"
                  >
                    <el-option
                      v-for="item in tabList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </div>
              </el-col>
              <el-col :span="16">
                <div class="search_box_item">
                  <div class="label">所属区域：</div>
                  <el-select
                    v-model="params.provinceCode"
                    class="el_select"
                    placeholder="省"
                    @change="provinceChange"
                  >
                    <el-option
                      v-for="item in provinceOptions"
                      :key="item.code"
                      :label="item.name"
                      :value="item.code"
                    >
                    </el-option>
                  </el-select>
                  <el-select
                    v-model="params.cityCode"
                    class="el_select"
                    placeholder="市"
                    @change="cityChange"
                  >
                    <el-option
                      v-for="item in cityOptions"
                      :key="item.code"
                      :label="item.name"
                      :value="item.code"
                    >
                    </el-option>
                  </el-select>
                  <el-select
                    v-model="params.countyCode"
                    class="el_select"
                    placeholder="县"
                    @change="countyChange"
                  >
                    <el-option
                      v-for="item in countyOptions"
                      :key="item.code"
                      :label="item.name"
                      :value="item.code"
                    >
                    </el-option>
                  </el-select>
                </div>
              </el-col>
              <el-col :span="4">
                <div class="btn_box">
                  <div @click="toSearch">搜索</div>
                  <div @click="toReset">重置</div>
                </div>
              </el-col>
            </el-row>
            <!--            </el-form>-->
          </div>
          <div class="title">{{ typeName }}</div>
          <div class="cell">
            <img src="../../assets/images/vip1.png" />
            <div class="cell_list th">
              <div>序号</div>
              <div>会员名称</div>
              <div>会员类型</div>
            </div>
          </div>
          <div v-for="(it, i) in vipList" :key="i" class="cell">
            <img src="../../assets/images/vip2.png" />
            <div class="cell_list">
              <div>
                {{ params.pageSize * params.pageNo - params.pageSize + i + 1 }}
              </div>
              <div style="cursor: pointer" @click="goToVipPage(it)">
                {{ it.dwmc }}
              </div>
              <div>{{ it.vipType }}</div>
            </div>
          </div>
          <div v-if="vipList.length != 0" class="common_page_box">
            <Page
              :current="params.pageNo"
              :page-size="params.pageSize"
              :total="total"
              show-total
              @on-change="changePage"
            ></Page>
          </div>
          <div v-if="vipList.length == 0" class="common_excel_no_more">
            暂无内容~
          </div>
        </div>
      </div>
    </div>
    <footerBox></footerBox>
    <Back-top :bottom="120" :height="100">
      <div class="iconfont icon-shangjiantou"></div>
    </Back-top>
  </div>
</template>

<script>
import bannerBox from "@/components/banner.vue";
import headerBox from "@/components/header.vue";
import footerBox from "@/components/footer.vue";
import { getDetatilArticle } from "@/api/home/index";
import { getVip } from "@/api/home/index";
import { getDqCode } from "@/api/home/basicInfo";
export default {
  name: "vipIndex",
  components: {
    bannerBox,
    headerBox,
    footerBox,
  },
  data() {
    return {
      newInfo: {},
      total: 0,
      params: {
        pageNo: 1,
        pageSize: 20,
        dwmc: "",
        type: "",
        areaCode: "",
        provinceCode: "",
        cityCode: "",
        countyCode: "",
      },
      catid: "",
      vipList: [],
      typeName: "",
      tabList: [
        {
          label: "全部",
          value: 0,
        },
        {
          label: "会长单位",
          value: 2,
        },
        // {
        // 	label: '副会长单位',
        // 	value:2
        // },
        {
          label: "监事单位",
          value: 3,
        },
        {
          label: "常务理事单位",
          value: 4,
        },
        {
          label: "理事单位",
          value: 6,
        },
        {
          label: "会员单位",
          value: 7,
        },
      ],
      tabList1: [
        {
          label: "全部",
          value: 0,
        },
        {
          label: "会长单位",
          value: 1,
        },
        {
          label: "副会长单位",
          value: 2,
        },
        {
          label: "监事单位",
          value: 3,
        },
        {
          label: "常务理事单位",
          value: 4,
        },
        {
          label: "副秘书长",
          value: 5,
        },
        {
          label: "理事单位",
          value: 6,
        },
        {
          label: "会员单位",
          value: 7,
        },
        {
          label: "监事长",
          value: 29,
        },
      ],
      propsCity: {
        lazy: true, // 启用懒加载
        lazyLoad: this.loadNode, // 指定懒加载方法
        // value: "code", // 数据唯一标识字段
        // label: "name", // 显示文本字段
        children: "children", // 子节点字段
        checkStrictly: true, // 是否严格遵循父子不关联
      },
      provinceOptions: [],
      cityOptions: [],
      countyOptions: [],
    };
  },
  mounted() {
    const savedPage = sessionStorage.getItem("newsPage");
    let index = "";
    if (savedPage) {
      // 判断是否有缓存分页
      // index = this.menuList.findIndex(
      //   (v) => v.catid == decodeURIComponent(JSON.parse(savedPage).catid),
      // );
      this.params.type = Number(JSON.parse(savedPage).catid);
      this.params = JSON.parse(savedPage);
    } else {
      this.params.type = Number(this.$route.query.type);
    }
    this.typeName = this.tabList.find(
      (v) => v.value == this.$route.query.type,
    ).label;

    this.$refs["bannerChild"].locationList = ["会员名录"];
    this.getVip();
    this.getProvince(0, 1);
  },
  methods: {
    /* ====================数据请求部分========================== */
    getVip() {
      getVip({
        // type: this.$route.query.type,
        ...this.params,
      }).then((res) => {
        if (res.code == 200 || res.code == 0) {
          let arr = res.result.records;
          if (arr.length > 0) {
            arr.map((v) => {
              v.vipType = this.tabList1.find((k) => k.value == v.type)
                ? this.tabList1.find((k) => k.value == v.type).label
                : v.type;
            });
          }
          this.vipList = arr;
          this.total = res.result.total;
        }
      });
    },
    /* ====================页面交互部分========================== */
    getType(e) {
      this.typeName = this.tabList.find((v) => v.value == e).label;
      this.getVip();
    },
    changePage(e) {
      this.params.pageNo = e;
      this.getVip();
    },
    goDetail(it) {
      this.$router.push({
        name: "/news_detail",
      });
    },
    toSearch() {
      this.params.pageNo = 1;
      this.getVip();
    },
    toReset() {
      this.params.pageNo = 1;
      this.params.dwmc = "";
      this.params.area = [];
      this.params.areaCode = "";
      this.params.provinceCode = "";
      this.params.cityCode = "";
      this.params.countyCode = "";
      sessionStorage.clear("newsPage");
      this.getVip();
    },
    goToVipPage(it) {
      this.$router.push({
        name: "vipInfo",
        query: {
          id: it.uuid,
        },
      });
      sessionStorage.setItem(
        "newsPage",
        JSON.stringify({
          ...this.params,
          catid: Number(it.type),
        }),
      );
    },
    getProvince(code, type) {
      // this.provinceOptions
      getDqCode({ code: code ? code : 0 }).then((res) => {
        if (type == 1) {
          this.provinceOptions = res.result;
        }
        if (type == 2) {
          this.cityOptions = res.result;
        }
        if (type == 3) {
          this.countyOptions = res.result;
        }
      });
    },
    provinceChange(val) {
      this.params.areaCode = val;
      this.params.cityCode = "";
      this.params.countyCode = "";
      this.cityOptions = [];
      this.getProvince(val, 2);
    },
    cityChange(val) {
      this.params.areaCode = val;
      this.countyOptions = [];
      this.params.countyCode = "";
      this.getProvince(val, 3);
    },
    countyChange(val) {
      this.params.areaCode = val;
    },
    async loadNode(node, resolve) {
      let fid = 0;
      // 根据节点层级设置父级ID
      if (node.level === 1) {
        fid = node.value; // 省级节点：取省级ID
      } else if (node.level === 2) {
        fid = node.value; // 市级节点：取市级ID
      }
      try {
        // 调用接口获取数据
        const res = await getDqCode({
          code: fid,
        });
        // 处理返回数据（根据实际接口结构调整）
        const rawData = res.result || [];
        // 转换数据格式
        const nodes = rawData.map((item) => ({
          value: item.code, // 节点值
          label: item.name, // 显示文本
          leaf: node.level >= 2, // 市级节点加载的数据设为叶子节点
        }));

        resolve(nodes);
      } catch (error) {
        console.error("数据加载失败:", error);
        resolve([]); // 必须调用resolve
      }
    },
    handleChange(val) {
      console.log("val-handleChange", val);
      console.log("val-handleChange", this.params.area);
      if (val.length > 2) {
        this.params.areaCode = val[2];
        // let LabelStr =
        //   this.$refs.CityRef.getCheckedNodes()[0].pathLabels.join("");
        // this.form.areaName = LabelStr;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.content_box {
  margin: 80px 200px;

  .cell {
    position: relative;

    img {
      width: 100%;
      margin: 0;
      padding: 0;
      vertical-align: top;
      // position: absolute;
    }

    .cell_list {
      position: absolute;
      bottom: 0;
      z-index: 99;
      height: 100%;
      width: 100%;
      display: flex;
      align-items: center;
      text-align: center;
      font-size: 14px;

      > div:first-child {
        width: 20%;
      }

      > div:nth-child(2) {
        width: 57%;
      }

      > div:last-child {
        width: 28%;
      }
    }

    .th {
      font-size: 15px;
    }
  }

  .page_box {
    padding-top: 40px;
    text-align: center;
  }
}

.title {
  font-size: 25px;
  text-align: center;
  margin-bottom: 50px;
  margin-top: 20px;
}

/deep/.ivu-select-selection,
/deep/.ivu-select-placeholder,
/deep/.ivu-select-selected-value {
  border-radius: 0 !important;
  height: 50px !important;
  line-height: 50px !important;
  width: 100%;
  margin-bottom: 10px;
  font-size: 14px !important;
  border-left: none !important;
  vertical-align: top;
}
.common_search_box /deep/.ivu-input {
  border-radius: 0 !important;
  height: 50px !important;
  line-height: 50px !important;
  width: 100%;
  margin-bottom: 10px;
  font-size: 14px !important;
  vertical-align: top;
}
.common_search_box /deep/ .el-cascader .el-input .el-input__inner {
  //height: 50px;
}
.common_search_box /deep/ .el-input--suffix .el-input__inner {
  //height: 50px;
}
.common_search_box /deep/ .el-input__inner {
  //height: 50px;
}
.common_search_box /deep/ .el-form-item__label {
  //line-height: 50px;
}
.common_search_box .search_box_item {
  display: flex;
  flex-direction: row;
  margin-bottom: 20px;
  .label {
    width: 100px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    font-weight: bold;
    text-align: right;
  }
  .el_select {
    margin-right: 10px;
  }
}

.gzdwInput {
  height: 50px !important;
  line-height: 50px !important;
  // background-color: red;
  input {
    height: 50px !important;
    line-height: 50px !important;
  }
}

/* 手机 */
@media only screen and (max-width: 800px) {
  .content_box {
    padding-bottom: 100px;
    padding-left: 0;
    padding-right: 0;
    > div {
      box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);
      border-radius: 10px;
      padding: 20px;
      margin: 0;
    }
  }
}
</style>
